import { useTranslations } from 'next-intl';
import Button from '@monofront/design-system/components/Button';
import useCompleteOrder from '../hooks/useCompleteOrder';
import { useCheckoutPayment } from '../contexts';

/**
 * Display a Pay CTA for a free order
 */
const PayNothingCta: React.FC = () => {
  const tCheckout = useTranslations('Checkout');
  const { isOrderValidationInProgress, setIsOrderValidationInProgress } =
    useCheckoutPayment();
  const { completeOrder } = useCompleteOrder();

  const validateOrder = async () => {
    setIsOrderValidationInProgress(true);

    await completeOrder();
  };

  return (
    <Button
      onClick={() => validateOrder()}
      isLoading={isOrderValidationInProgress}
      dataTestId={`Pay-Nothing-Cta`}
    >
      {tCheckout('finishCheckout')}
    </Button>
  );
};

export default PayNothingCta;
